import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.policies.create.title',
    defaultMessage: 'New Policy',
  },
});

export default function AdminPoliciesCreatePage() {
  const { formatMessage } = useIntl();
  return (
    <AdminManagement.Layout
      maxContentWidth="md"
      title={formatMessage(messages.title)}
    >
      <BigCircle />
      <AdminManagement.Policies.Create />
    </AdminManagement.Layout>
  );
}
